import { useRef } from 'react';

export default function Features() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'No-Log Policy',
      description: 'We never track, collect, or store your online activity. Your privacy is guaranteed with our strict no-log policy.',
      category: 'PRIVACY'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Connect up to 10 devices simultaneously. Works seamlessly on Windows, Mac, iOS, Android, and Linux.',
      category: 'COMPATIBILITY'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Auto-Reconnect',
      description: 'Automatic reconnection ensures your VPN protection never drops, even when switching networks.',
      category: 'RELIABILITY'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'Kill Switch',
      description: 'Instantly blocks all internet traffic if your VPN connection drops, preventing any data leaks.',
      category: 'SECURITY'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Support',
      description: 'Our expert support team is available around the clock to assist you with any questions or issues.',
      category: 'SUPPORT'
    }
  ];

  return (
    <section id="features" className="py-32 bg-[#0A1628]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex flex-col lg:flex-row gap-8 mb-12">
          <div className="lg:w-1/3">
            <p className="text-gray-400 text-sm mb-2 font-light">WHAT WE OFFER</p>
            <h2 className="text-5xl font-bold text-white tracking-wide">
              Advanced Features
            </h2>
          </div>
          <div className="lg:w-2/3">
            <p className="text-gray-300 text-base leading-relaxed">
              Our VPN service comes packed with powerful features designed to give you complete control over your online security and privacy. Experience the difference with ESVICOL VPN.
            </p>
          </div>
        </div>

        <div 
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto pb-6 scrollbar-hide"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-80 bg-gradient-to-br from-[#1a2942] to-[#0f1a2e] rounded-2xl p-8 relative"
            >
              <div className="absolute top-6 left-6 bg-[#CCFF00] text-[#0A1628] text-xs font-bold px-3 py-1 rounded-full">
                {feature.category}
              </div>
              
              <div className="mt-12 mb-6">
                <i className={`${feature.icon} text-6xl text-[#00D9FF]`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-4">
                {feature.title}
              </h3>
              
              <p className="text-gray-400 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <style>{`
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
        `}</style>
      </div>
    </section>
  );
}
